import { render, staticRenderFns } from "./RecoMobile.vue?vue&type=template&id=09b26a5c&scoped=true"
import script from "./RecoMobile.vue?vue&type=script&lang=js"
export * from "./RecoMobile.vue?vue&type=script&lang=js"
import style0 from "./RecoMobile.vue?vue&type=style&index=0&id=09b26a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b26a5c",
  null
  
)

export default component.exports